import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Helmet } from 'react-helmet';
var MetaData = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(MetaData, _React$Component);
    function MetaData() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = MetaData.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("meta", {
            charSet: "utf-8"
        }), /*#__PURE__*/ React.createElement("title", null, this.props.title), /*#__PURE__*/ React.createElement("meta", {
            property: "description",
            content: this.props.description
        }), /*#__PURE__*/ React.createElement("meta", {
            property: "og:title",
            content: this.props.title
        }), /*#__PURE__*/ React.createElement("meta", {
            property: "og:description",
            content: this.props.description
        }), /*#__PURE__*/ React.createElement("meta", {
            property: "og:image",
            content: "https://www.drewtempleton.com" + this.props.photos.facebook.src
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:description",
            content: this.props.description
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:site",
            content: "@drewbietron"
        }), /*#__PURE__*/ React.createElement("meta", {
            itemProp: "image",
            content: "https://www.drewtempleton.com" + this.props.photos.full.src
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:image",
            content: "https://www.drewtempleton.com" + this.props.photos.twitter.src
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:image:src",
            content: this.props.photos.twitter.src
        }), /*#__PURE__*/ React.createElement("meta", {
            itemProp: "name",
            content: this.props.title
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:title",
            content: this.props.title
        }), /*#__PURE__*/ React.createElement("meta", {
            name: "twitter:title",
            content: this.props.title
        }));
    };
    return MetaData;
}(React.Component);
export { MetaData as default };
